import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarMinimalFilterDropdownContent from './VeltCommentsSidebarMinimalFilterDropdownContent/VeltCommentsSidebarMinimalFilterDropdownContent';
import VeltCommentsSidebarMinimalFilterDropdownTrigger from './VeltCommentsSidebarMinimalFilterDropdownTrigger/VeltCommentsSidebarMinimalFilterDropdownTrigger';
;
var VeltCommentsSidebarMinimalFilterDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarMinimalFilterDropdown.Trigger = VeltCommentsSidebarMinimalFilterDropdownTrigger;
VeltCommentsSidebarMinimalFilterDropdown.Content = VeltCommentsSidebarMinimalFilterDropdownContent;
export default VeltCommentsSidebarMinimalFilterDropdown;
